<template>
    <div class="border bg-gray-100 rounded p-4 mt-3">
        <div class="mb-4">Video</div>
            <input-text
                label="Url"
                name="url"
                v-model="data.url"
                class="ml-3 w-full mt-5"
                :maxlength="255"
            />

            <input-text
                label="Private Hash (only for Vimeo)"
                name="private_hash"
                v-model="data.private_hash"
                class="ml-3 w-full mt-5"
                :maxlength="255"
            />
        </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
    components: { draggable },
    name: "VideoElement",
    props: {
        value: [Object, Array]
    },
    data() {
        return {
            data: {
                url: this.value?.url ?? null,
                private_hash: this.value?.private_hash ?? null,
            },
        };
    },
    updated() {
        this.$emit("input", this.data);
    },
    watch: {
        value: function (newValue) {
            this.data = newValue;
        }
    }
};
</script>
